var Prompt = require('/src/components/ui/prompt');

module.exports = function(renameButton, {filter} = {}) {
	var _t = this;

	var onstartrename = on(this, 'startRename');
	var onrename = on(this, 'rename');
	
	onstartrename.then(function() {
		var p = new Prompt({
			prompt: 'New name:',
			response: _t.name
		});
		on(p, 'ok').then(function(v) {
			if (typeof filter === 'function') {
				v = filter(v);
			}
			var oldname = _t.name;
			_t.name = v;
			onrename.fire(v);
			on(_t, 'change').fire(_t);
		});
	});

	if (this.renameButton) {
		this.renameButton.onclick = function() {
			onstartrename.fire();
		};
	}

	return onstartrename;

};
